import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { isLyrraOne } from '@/lib/platform';
import { useLyrraOnePlan } from '@/hooks/useLyrraOnePlan';
import { LYRRAONE_SUBSCRIPTION_PATH } from '@/lib/lyrraone-plan';

const QUOTA_LABELS: Record<string, string> = {
  publishedFormations: 'formations publiées',
  activeFunnels: 'funnels actifs',
  contacts: 'contacts',
  emailsPerMonth: 'emails / mois',
  activeAutomations: 'automatisations actives',
  sitePages: 'pages site',
  blogPosts: 'articles de blog',
  communities: 'communautés',
  webinars: 'webinaires',
  bookingTypes: 'types de rendez-vous',
  affiliates: 'affiliés',
  smsPerMonth: 'SMS / mois',
};

type LyrraOnePlanQuotaBannerProps = {
  limitKey: string;
  /** Si false, n’affiche rien quand le quota n’est pas atteint. */
  onlyWhenBlocked?: boolean;
  className?: string;
};

export function LyrraOnePlanQuotaBanner({
  limitKey,
  onlyWhenBlocked = true,
  className = '',
}: LyrraOnePlanQuotaBannerProps) {
  const { isLyrraOne: lo, quota, plan } = useLyrraOnePlan();
  const q = quota(limitKey);

  if (!lo || q.unlimited || (onlyWhenBlocked && !q.atLimit)) return null;

  const label = QUOTA_LABELS[limitKey] ?? limitKey;
  const planLabel = plan === 'expert' ? 'Expert' : plan === 'creator' ? 'Créateur' : 'Gratuit';

  return (
    <div
      className={`flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100 ${className}`}
      role="status"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <p>
        Limite plan {planLabel} atteinte pour les {label} ({q.used} / {q.limit}).{' '}
        <Link to={LYRRAONE_SUBSCRIPTION_PATH} className="font-semibold underline">
          Passer à une offre supérieure
        </Link>
      </p>
    </div>
  );
}
